import { useMemo } from 'react';
import { App } from '@gin-betting/core';

import { State } from '../types';
import usePureSelector from './usePureSelector';

const useMemoSelector = <
    TSelected,
    TProps,
    TState extends App.BaseState = State
>(
    selector: (state: TState, input?: TProps) => TSelected,
    input?: TProps,
    dependencies: any[] = []
) => {
    /* eslint-disable-next-line */
    const selectProps = useMemo(() => selector, dependencies);

    return usePureSelector((state: State) =>
        selectProps(state as TState, input)
    );
};

export default useMemoSelector;
